module.exports = __webpack_public_path__ + "img/jbtyk01.f87a2288.png";